export const GET_TASKS = gql`
  query GetTasks($filters: TaskFiltersInput, $pageInfo: PageInfoInput) {
    tasks(filters: $filters, pageInfo: $pageInfo) {
      items {
        taskId
        createdAt
        updatedAt
        title
        description
        status
        type
        priority
        dueDate
        reminderDate
        applicant {
          applicantId
          firstName
          lastName
          phone
        }
        company {
          companyId
        }
        assignees {
          employeeId
          firstName
          lastName
        }
      }
      totalCount
      pageInfo {
        limit
        offset
      }
    }
  }
`

export const GET_TASK = gql`
  query GetTask($taskId: String!) {
    task(taskId: $taskId) {
      taskId
      createdAt
      updatedAt
      title
      description
      status
      type
      priority
      dueDate
      reminderDate
      applicant {
        applicantId
        firstName
        lastName
      }
      company {
        companyId
      }
      assignees {
        employeeId
        firstName
        lastName
      }
    }
  }
`

export const CREATE_TASK = gql`
  mutation CreateTask($input: CreateTaskInput!) {
    createTask(input: $input) {
      taskId
      createdAt
      updatedAt
      title
      assignees {
        employeeId
        firstName
        lastName
      }
    }
  }
`

export const UPDATE_TASK = gql`
  mutation UpdateTask($taskId: String!, $input: UpdateTaskInput!) {
    updateTask(taskId: $taskId, input: $input) {
      taskId
      createdAt
      updatedAt
      title
      assignees {
        employeeId
        firstName
        lastName
      }
    }
  }
`

export const EXPORT_TASKS_AS_CSV = gql`
  mutation ExportTasksAsCsv($filters: TaskFiltersInput) {
    exportTasksAsCsv(filters: $filters)
  }
`
